import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { LottosService } from '../../services/lottos/lottos.service';
import { GlobalsService } from 'src/app/services/globals/globals.service';

@Component({
  selector: 'app-jackpot',
  templateUrl: './jackpot.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./jackpot.component.scss']
})
export class JackpotComponent implements OnInit {
  public jackpot: number;
  public country: string;
  public currency: string;
  public system: string;
  public lottoId: number;
  public subs: Subscription;
  constructor(protected lotto: LottosService, private _globalService: GlobalsService) {
    this.system = this._globalService.getSystem().site;
  }

  ngOnInit(): void {
    this.setJackpot();
    this.setLottoId();
  }

  setJackpot() {
    this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.jackpot = lottoObj['jackpot'];
      this.currency = lottoObj['currency'];
      this.country = lottoObj['name'];
      this.country = lottoObj['country'];
    });
  }

  setLottoId(): void {
    this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.lottoId = lottoObj['id'];
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
